var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"progress"}},[_c('div',{style:({ width: this.progress + '%' })})]),_c('site-header'),_c('sidebar'),_c('main',[_c('router-view'),(_vm.isLogged && _vm.user.perm.execute)?_c('shell'):_vm._e()],1),_c('prompts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }